export const SET_HUBS = 'SET_HUBS';
export const SET_HUB = 'SET_HUB';
export const REMOVE_HUB = 'REMOVE_HUB';
export const CHANGE_HUB_ACTIVITY_STATUS = 'CHANGE_HUB_ACTIVITY_STATUS';
export const RESET_HUBS = 'RESET_HUBS';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_HUBS_ERROR = 'SET_HUBS_ERROR';
